import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "@/shared/utils";

const EverySixSeconds = ({ wrapperClass }: { wrapperClass?: string }) => {
    return (
        <>
            <div
                data-testid="every-six-seconds"
                className={cn(
                    "rounded-lg bg-background-frame px-4 py-3 text-content-primary-invert xs:mx-auto xs:w-[360px] xs:px-5 sm:px-7 sm:py-5 md:px-9 md:py-6 lg:w-[370px] lg:px-9",
                    wrapperClass
                )}
            >
                <div className="flex items-start justify-between">
                    <div className="flex flex-col items-start gap-2 xs:flex-row-reverse xs:items-center xs:gap-2">
                        <div className="flex">
                            <FontAwesomeIcon icon={faClock} className="size-5 rounded-full bg-content-primary-invert text-content-inactive xs:size-4 lg:size-5" />
                        </div>
                        <div className="flex gap-1 text-lg font-semibold text-content-frame">Every 6 Seconds</div>
                    </div>
                    <div
                        className={cn(
                            "-mr-4 -mt-3 flex rounded-lg rounded-br-none rounded-tl-none bg-background-brand-secondary px-3 py-1 text-xs leading-5 text-content-frame xs:-mr-5 sm:-mr-7 sm:-mt-5 md:-mr-9 md:-mt-6 md:text-sm lg:-mr-9 dark:text-content-primary-invert"
                        )}
                    >
                        Did you know?
                    </div>
                </div>
                <div className="text-sm leading-7 text-content-frame sm:text-base lg:leading-8">
                    a pet owner is faced with a vet bill of
                    <br />
                    <span className="text-xl font-bold text-background-primitive--brand-400">$1,000</span>
                    <span className="ml-1 text-xl font-semibold">
                        or more.
                        <span className="text-sm">
                            <sup>7</sup>
                        </span>
                    </span>
                </div>
            </div>
        </>
    );
};

export default EverySixSeconds;
